import ImageWIthSignedUrl from "components/S3Utility/ImageWIthSignedUrl";
import React from "react";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { truncateString } from "utils/UtilityFuncs";

export default function ProductAccordion({
  product,
  sizes,
  totalQty,
  shippedQty,
  pendingQty,
  getProductStatus,
  shipmentQtyByProduct,
  setShipmentQtyByProduct,
  selectedProducts,
  setSelectedProducts,
  expandedProducts,
  setExpandedProducts,
  handleDoneToAddProduct,
  productLoading,
}) {
  /*   All States
   ********************************************* */
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);

  /*   All Functions
   ********************************************* */

  // Shipment qty input change
  const handleQtyChange = (productId, sizeId, value) => {
    setShipmentQtyByProduct((prev) => {
      const sizes = prev[productId]?.map((size) =>
        size.id === sizeId ? { ...size, shipmentQty: Number(value) } : size
      );
      return { ...prev, [productId]: sizes };
    });

    // Select product if not already selected and deselect if qty is 0 for all sizes
    const totalShipmentQty = shipmentQtyByProduct[productId]?.reduce(
      (acc, size) =>
        acc + (size.id === sizeId ? Number(value) : size.shipmentQty),
      0
    );
    if (totalShipmentQty > 0) {
      if (!selectedProducts.some((p) => p.id === productId)) {
        setSelectedProducts((prev) => [...prev, product]);
      }
    } else {
      setSelectedProducts((prev) => prev.filter((p) => p.id !== productId));
    }
  };

  // Ship all sizes for a product
  const handleShipAllSizes = (productId) => {
    setShipmentQtyByProduct((prev) => {
      const sizes = prev[productId]?.map((size) => ({
        ...size,
        shipmentQty: Number(size.quantity),
      }));
      return { ...prev, [productId]: sizes };
    });
  };

  // Checkbox select logic
  const handleProductCheckbox = (product) => {
    setSelectedProducts((prev) =>
      prev.some((p) => p.id === product.id)
        ? prev.filter((p) => p.id !== product.id)
        : [...prev, product]
    );
    // If unchecking, reset qtys
    if (selectedProducts.some((p) => p.id === product.id)) {
      setShipmentQtyByProduct((prev) => {
        const sizes = prev[product.id]?.map((size) => ({
          ...size,
          shipmentQty: 0,
        }));
        return { ...prev, [product.id]: sizes };
      });
      // collapse accordion
      setExpandedProducts((prev) => prev.filter((id) => id !== product.id));
    }
  };
  // Accordion expand/collapse
  const handleAccordionToggle = (productId) => {
    setExpandedProducts((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <Accordion.Item
      className="border-0 shadow-sm mb-2"
      eventKey={product.id}
      key={product.id}
    >
      <Accordion.Header
        onClick={() => handleAccordionToggle(product.id)}
        style={{
          borderRadius: 6,
          padding: 0,
          // background: "rgba(13, 110, 253, 0.15)",
        }}
        className={`border mt-2  bg-${
          getProductStatus(product.id) !== "secondary"
            ? `${getProductStatus(product.id)} bg-opacity-25`
            : "white"
        }`}
      >
        <div className="d-flex align-items-center w-100" style={{ gap: 0 }}>
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={selectedProducts.some((p) => p.id === product.id)}
            onChange={(e) => {
              e.stopPropagation();
              let checked = e.target.checked;
              handleProductCheckbox(product);
              // toggle only if not open
              if (!expandedProducts.includes(product.id) && checked) {
                handleAccordionToggle(product.id);
              }
            }}
            onClick={(e) => e.stopPropagation()}
          />

          {/* product?.WorkOrder?.woId */}
          {(user?.permissions?.includes("work_orders_add") ||
            user?.permissions?.includes("work_orders_update") ||
            user?.permissions?.includes("work_orders_delete") ||
            user?.permissions?.includes("work_orders_dataEntry") ||
            user?.roles === "admin") && (
            <button
              onClick={(e) => {
                navigate(
                  `/work-order/details/${product?.WorkOrder?.WOStatus}/${product?.WorkOrder?.woId}?page=1`
                );
              }}
              className="btn btn-sm btn-info py-0"
            >
              View
            </button>
          )}
          <span className="mx-2 text-nowrap">W-{product?.WorkOrder?.woId}</span>

          <div
            style={{
              width: 50,
              minWidth: 50,
              height: 30,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            // onClick={(e) => {
            //   e.stopPropagation();
            //   setImageToView(product.productImage);
            //   setShowImageModal(true);
            // }}
          >
            {product.productImage ? (
              <ImageWIthSignedUrl
                path={product.productImage}
                width={50}
                height={30}
                style={{ objectFit: "cover", borderRadius: 6 }}
              />
            ) : (
              <div
                style={{
                  width: 50,
                  height: 30,
                  background: "#f0f0f0",
                  borderRadius: 6,
                }}
              />
            )}
          </div>
          <div style={{ width: 120, minWidth: 120, paddingLeft: 12 }}>
            <strong>{product.productTypes?.productTypes || "-"}</strong>
          </div>
          <div style={{ width: 150, minWidth: 100, paddingLeft: 12 }}>
            <strong>{product.productStyle || "-"}</strong>
          </div>
          <div style={{ width: 250, minWidth: 200, paddingLeft: 12 }}>
            {truncateString(product.productDescription, 28) || "-"}
          </div>

          <div style={{ width: 150, minWidth: 100 }}>
            {product.productColor || "-"}
          </div>
          <div style={{ width: 150, minWidth: 100 }}>
            {product.productFabric || "-"}
          </div>
          <div
            style={{
              flex: 1,
              width: 80,
              minWidth: 60,
              textAlign: "center",
            }}
          >
            {/* (<span>{product?.WorkOrder?.WOStatus}</span>) */}
            <span className="badge py-1 fs-6 bg-secondary">
              Qty: {product.totalQuantity}
            </span>
          </div>
        </div>
      </Accordion.Header>
      <Accordion.Body className="bg-white mb-2">
        {/* Show large Product Image */}
        <div className="mb-2 text-center bg-light p-2 rounded-3">
          {product.productImage && (
            <ImageWIthSignedUrl
              path={product.productImage}
              alt={product.productStyle}
              imgClasses={"rounded-3"}
              imgStyle={{ maxHeight: 300, objectFit: "contain" }}
            />
          )}
        </div>
        <hr />
        {/* Ship All Button and summary row */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleShipAllSizes(product.id)}
            >
              Ship All
            </button>
            <button
              onClick={() => handleDoneToAddProduct(product)}
              type="button"
              className="btn btn-success btn-sm ms-1"
              disabled={shippedQty === 0 || productLoading}
            >
              Done
            </button>
          </div>
          <div className="d-flex align-items-center gap-3">
            <span>
              <strong>Total:</strong> {totalQty}
            </span>
            <span>
              <strong>Shipped:</strong> {shippedQty}
            </span>
            <span>
              <strong>Pending:</strong> {pendingQty}
            </span>
          </div>
        </div>
        {/* Pills for sizes */}
        <div
          className="d-flex flex-row flex-wrap gap-2"
          style={{ marginBottom: 8 }}
        >
          {sizes.map((size) => (
            <div
              key={size.id}
              className="d-flex align-items-center border rounded-pill px-2 py-1 bg-light"
              style={{
                minWidth: 110,
                marginBottom: 4,
                boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
              }}
            >
              {/* Checkbox for this size */}
              <input
                type="checkbox"
                className="form-check-input me-1"
                checked={size.shipmentQty !== 0}
                // checked={size.shipmentQty === Number(size.quantity)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  handleQtyChange(
                    product.id,
                    size.id,
                    checked ? Number(size.quantity) : 0
                  );
                }}
                style={{ cursor: "pointer" }}
              />
              <span className="fw-bold me-1">{size.sizeName || size.size}</span>
              <span className="badge bg-secondary me-1">
                {size.shipmentQty}/{size.quantity}
              </span>
              <input
                type="number"
                min={0}
                max={size.quantity}
                value={size.shipmentQty}
                onChange={(e) => {
                  let val = Math.max(
                    0,
                    Math.min(Number(e.target.value), size.quantity)
                  );
                  handleQtyChange(product.id, size.id, val);
                }}
                className="form-control form-control-sm"
                style={{ width: 70, marginLeft: 2 }}
              />
            </div>
          ))}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
